import * as React from 'react';

const Article = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.5" stroke="#E4E7EC" />
    <path
      d="M5 8.5625C5 8.25781 5.23438 8 5.5625 8H14.9375C15.2422 8 15.5 8.25781 15.5 8.5625C15.5 8.89062 15.2422 9.125 14.9375 9.125H5.5625C5.23438 9.125 5 8.89062 5 8.5625ZM6.5 12.3125C6.5 12.0078 6.73438 11.75 7.0625 11.75H16.4375C16.7422 11.75 17 12.0078 17 12.3125C17 12.6406 16.7422 12.875 16.4375 12.875H7.0625C6.73438 12.875 6.5 12.6406 6.5 12.3125ZM14.9375 16.625H5.5625C5.23438 16.625 5 16.3906 5 16.0625C5 15.7578 5.23438 15.5 5.5625 15.5H14.9375C15.2422 15.5 15.5 15.7578 15.5 16.0625C15.5 16.3906 15.2422 16.625 14.9375 16.625Z"
      fill="#293055"
    />
  </svg>
);
export default Article;
